var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEllipseGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 122,
    viewBox: "0 0 386 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_39_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.596 18.3732C377.946 19.888 377.56 21.8637 375.816 24.4345C374.074 27.0022 371.152 29.8871 367.019 33.0208C358.766 39.2773 346.163 46.1682 330.061 53.2522C297.893 67.4033 252.23 82.1215 200.709 94.016C149.188 105.911 101.694 112.699 66.5791 114.082C49.0006 114.774 34.653 114.105 24.4925 112.099C19.4035 111.095 15.513 109.783 12.8216 108.238C10.1268 106.692 8.91409 105.086 8.56438 103.571C8.21468 102.056 8.60034 100.08 10.3446 97.5096C12.0868 94.9419 15.0083 92.057 19.142 88.9234C27.395 82.6668 39.9973 75.776 56.1001 68.692C88.2673 54.5408 133.931 39.8226 185.452 27.9281C236.972 16.0336 284.466 9.24471 319.582 7.86248C337.16 7.17054 351.508 7.83953 361.668 9.84497C366.757 10.8494 370.648 12.1616 373.339 13.7057C376.034 15.2518 377.247 16.8585 377.596 18.3732Z",
    stroke: "#74EBD5",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_39_37",
    x: 0.94574,
    y: 0.098175,
    width: 384.269,
    height: 121.748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_39_37"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseGreen);
export default __webpack_public_path__ + "static/media/EllipseGreen.75700fd86f4ecff3745a36037c5600d2.svg";
export { ForwardRef as ReactComponent };